export const  BaseUrl:string="https://candidatecrm20250109181437.azurewebsites.net"
export const  BaseUrl1:string= "https://localhost:7183"

